// extracted by mini-css-extract-plugin
module.exports = {"button":"copy-to-clipboard-button_button__4gOI0","copied":"copy-to-clipboard-button_copied__S7jI8","customText":"copy-to-clipboard-button_customText__6uvef"};